import { hasAnyRoleUtil, isRoleUtil } from "../utils/roleAliases";

export const TASK_MANAGER_MODULE_ADMIN = "TASK_MANAGER_MODULE_ADMIN";
export const SERALOGIN_TASK_MANAGER_ACCESS = "SERALOGIN_TASK_MANAGER_ACCESS";
export const TASK_MANAGER_TASK_ADMIN = "TASK_MANAGER_TASK_ADMIN";
export const TASK_MANAGER_INDICATORS_ADMIN = "TASK_MANAGER_INDICATORS_ADMIN";
export const TASK_MANAGER_REPORT_DOWNLOADER = "TASK_MANAGER_REPORT_DOWNLOADER";
export const TASK_MANAGER_JUSTIFIED_ACTIVITIES_ADMIN =
  "TASK_MANAGER_JUSTIFIED_ACTIVITIES_ADMIN";

export const TASK_MANAGER_PROCESS_LEADER_BY_PROCESS = {
  1: "TASK_MANAGER_PROCESS_LEADER_ADMINISTRATIVE_MANAGEMENT",
  2: "TASK_MANAGER_PROCESS_LEADER_BIOMEDICAL_MANAGEMENT",
  3: "TASK_MANAGER_PROCESS_LEADER_COMMERCIAL_MANAGEMENT",
  4: "TASK_MANAGER_PROCESS_LEADER_HUMAN_RESOURCES_MANAGEMENT",
  5: "TASK_MANAGER_PROCESS_LEADER_HSQ_MANAGEMENT",
  6: "TASK_MANAGER_PROCESS_LEADER_MARKETING_AND_PROMOTION_MANAGEMENT",
  7: "TASK_MANAGER_PROCESS_LEADER_CUSTOMER_SERVICE_MANAGEMENT",
  8: "TASK_MANAGER_PROCESS_LEADER_FINANCIAL_AND_ACCOUNTING_MANAGEMENT",
  9: "TASK_MANAGER_PROCESS_LEADER_PHARMACEUTICAL_MANAGEMENT",
  10: "TASK_MANAGER_PROCESS_LEADER_MANAGEMENT_DIRECTION",
  11: "TASK_MANAGER_PROCESS_LEADER_FOREIGN_TRADE_DIRECTION",
  12: "TASK_MANAGER_PROCESS_LEADER_TECHNICAL_SUPPORT_DIRECTION",
  13: "TASK_MANAGER_PROCESS_LEADER_SAFETY_AND_HEALTH_AT_WORK",
  14: "TASK_MANAGER_PROCESS_LEADER_FOREIGN_TRADE_MANAGEMENT",
  15: "TASK_MANAGER_PROCESS_LEADER_CUSTOMER_SERVICE_PHARMADIA"
};

export const TASK_MANAGER_PROCESS_COLLABORATOR_BY_PROCESS = {
  1: "TASK_MANAGER_PROCESS_COLLABORATOR_ADMINISTRATIVE_MANAGEMENT",
  2: "TASK_MANAGER_PROCESS_COLLABORATOR_BIOMEDICAL_MANAGEMENT",
  3: "TASK_MANAGER_PROCESS_COLLABORATOR_COMMERCIAL_MANAGEMENT",
  4: "TASK_MANAGER_PROCESS_COLLABORATOR_HUMAN_RESOURCES_MANAGEMENT",
  5: "TASK_MANAGER_PROCESS_COLLABORATOR_HSQ_MANAGEMENT",
  6: "TASK_MANAGER_PROCESS_COLLABORATOR_MARKETING_AND_PROMOTION_MANAGEMENT",
  7: "TASK_MANAGER_PROCESS_COLLABORATOR_CUSTOMER_SERVICE_MANAGEMENT",
  8: "TASK_MANAGER_PROCESS_COLLABORATOR_FINANCIAL_AND_ACCOUNTING_MANAGEMENT",
  9: "TASK_MANAGER_PROCESS_COLLABORATOR_PHARMACEUTICAL_MANAGEMENT",
  10: "TASK_MANAGER_PROCESS_COLLABORATOR_MANAGEMENT_DIRECTION",
  11: "TASK_MANAGER_PROCESS_COLLABORATOR_FOREIGN_TRADE_DIRECTION",
  12: "TASK_MANAGER_PROCESS_COLLABORATOR_TECHNICAL_SUPPORT_DIRECTION",
  13: "TASK_MANAGER_PROCESS_COLLABORATOR_SAFETY_AND_HEALTH_AT_WORK",
  14: "TASK_MANAGER_PROCESS_COLLABORATOR_FOREIGN_TRADE_MANAGEMENT",
  15: "TASK_MANAGER_PROCESS_COLLABORATOR_CUSTOMER_SERVICE_PHARMADIA"
};

export const TASK_MANAGER_PROCESS_LEADER_ROLES = Object.values(
  TASK_MANAGER_PROCESS_LEADER_BY_PROCESS
);

export const TASK_MANAGER_PROCESS_COLLABORATOR_ROLES = Object.values(
  TASK_MANAGER_PROCESS_COLLABORATOR_BY_PROCESS
);

export const TASK_ROLES = [
  TASK_MANAGER_MODULE_ADMIN,
  SERALOGIN_TASK_MANAGER_ACCESS,
  TASK_MANAGER_TASK_ADMIN,
  TASK_MANAGER_INDICATORS_ADMIN,
  TASK_MANAGER_REPORT_DOWNLOADER,
  TASK_MANAGER_JUSTIFIED_ACTIVITIES_ADMIN,
  ...TASK_MANAGER_PROCESS_LEADER_ROLES,
  ...TASK_MANAGER_PROCESS_COLLABORATOR_ROLES
];

const LEGACY_MODULE_ADMIN_ROLES = ["TASK_MANAGER", "TASK_MANAGER_ADMIN"];
const LEGACY_TASK_ADMIN_ROLES = ["TASK_MANAGER_ADMIN"];
const LEGACY_INDICATORS_ROLES = ["TASK_MANAGER_INDICATORS_VIEWER"];
const LEGACY_JUSTIFIED_ROLES = ["TASK_MANAGER_ADMIN_JUSTIFIED_ACTIVITIES"];

const hasRoleStartingWith = (roleList = [], prefix) =>
  (roleList || []).some((role) =>
    String(role || "")
      .trim()
      .toUpperCase()
      .startsWith(prefix)
  );

export const isTaskManagerModuleAdmin = (roleList = []) =>
  hasAnyRoleUtil(
    [TASK_MANAGER_MODULE_ADMIN, ...LEGACY_MODULE_ADMIN_ROLES],
    roleList
  );

export const canAssignAnyTask = (roleList = []) =>
  hasAnyRoleUtil(
    [TASK_MANAGER_MODULE_ADMIN, TASK_MANAGER_TASK_ADMIN, ...LEGACY_TASK_ADMIN_ROLES],
    roleList
  );

export const canAssignProcessTasks = (roleList = []) =>
  canAssignAnyTask(roleList) ||
  TASK_MANAGER_PROCESS_LEADER_ROLES.some((role) => isRoleUtil(role, roleList)) ||
  hasRoleStartingWith(roleList, "TASK_MANAGER_ADMIN_") ||
  hasRoleStartingWith(roleList, "TASK_MANAGER_CREATOR_ALL_");

export const canCreateOwnTasks = (roleList = []) =>
  TASK_MANAGER_PROCESS_COLLABORATOR_ROLES.some((role) =>
    isRoleUtil(role, roleList)
  ) || hasRoleStartingWith(roleList, "TASK_MANAGER_ASSIGNEE_");

export const canManageTaskCards = (roleList = []) =>
  canAssignProcessTasks(roleList);

export const canCompleteAssignedTasks = (roleList = []) =>
  canManageTaskCards(roleList) ||
  TASK_MANAGER_PROCESS_COLLABORATOR_ROLES.some((role) =>
    isRoleUtil(role, roleList)
  ) ||
  hasRoleStartingWith(roleList, "TASK_MANAGER_ASSIGNEE_") ||
  hasRoleStartingWith(roleList, "TASK_MANAGER_SUB_ASSIGNEE_");

export const canViewManagementIndicators = (roleList = []) =>
  hasAnyRoleUtil(
    [
      TASK_MANAGER_MODULE_ADMIN,
      TASK_MANAGER_INDICATORS_ADMIN,
      ...LEGACY_MODULE_ADMIN_ROLES,
      ...LEGACY_INDICATORS_ROLES
    ],
    roleList
  ) ||
  TASK_MANAGER_PROCESS_LEADER_ROLES.some((role) => isRoleUtil(role, roleList)) ||
  hasRoleStartingWith(roleList, "TASK_MANAGER_ADMIN_") ||
  hasRoleStartingWith(roleList, "TASK_MANAGER_CREATOR_ALL_") ||
  hasRoleStartingWith(roleList, "TASK_MANAGER_INDICATORS_VIEWER_") ||
  hasRoleStartingWith(roleList, "TASK_MANAGER_SUB_LEADER_");

export const canViewGlobalManagementIndicators = (roleList = []) =>
  hasAnyRoleUtil(
    [
      TASK_MANAGER_MODULE_ADMIN,
      TASK_MANAGER_INDICATORS_ADMIN,
      ...LEGACY_MODULE_ADMIN_ROLES,
      ...LEGACY_INDICATORS_ROLES
    ],
    roleList
  );

export const canDownloadTaskReport = (roleList = []) =>
  hasAnyRoleUtil(
    [
      TASK_MANAGER_MODULE_ADMIN,
      TASK_MANAGER_REPORT_DOWNLOADER,
      "TASK_MANAGER_ADMIN"
    ],
    roleList
  );

export const canManageJustifiedActivities = (roleList = []) =>
  hasAnyRoleUtil(
    [
      TASK_MANAGER_MODULE_ADMIN,
      TASK_MANAGER_JUSTIFIED_ACTIVITIES_ADMIN,
      ...LEGACY_JUSTIFIED_ROLES
    ],
    roleList
  );
